import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AccountDashboard } from 'common/api/contentful/models/AccountDashboard';
import { useFromContentful } from 'common/api/contentful/utils';
import { ActivityIndicator } from 'components/activity-indicator/ActivityIndicator';
import { Btn } from 'components/btn/Btn';
import React, { useMemo } from 'react';

export const SuccessMessage = ({ orgName, onClose }: { orgName: string; onClose: () => void }) => {
    const accountDashboard = useFromContentful<AccountDashboard>('accountDashboard');
    const successTexts = useMemo(
        () => accountDashboard?.content?.items[0].fields,
        [accountDashboard]
    );

    if (accountDashboard.isLoading) {
        return (
            <div className="p-16 flex self-center">
                <ActivityIndicator width="80px" />
            </div>
        );
    }
    return (
        <div className="p-4 pt-0">
            <div className="flex justify-center mb-4">
                <FontAwesomeIcon
                    className="text-success font-semibold text-5xl"
                    icon={faCheckCircle}
                />
            </div>
            <div className="text-base text-brand text-center">
                <div className="text-22px sm:text-29px font-semibold">
                    {successTexts?.joinSuccessTitle}
                </div>
                <div className="text-lg text-grey-2 flex flex-col items-center mt-2">
                    <div>
                        {successTexts?.joinSuccessSubtitle} {orgName}
                    </div>
                </div>
                {successTexts?.joinOrgSuccessBody ? (
                    <div className="text-lg text-grey-2 flex flex-col items-center mt-10">
                        {successTexts?.joinOrgSuccessBody}
                    </div>
                ) : null}
                {successTexts?.joinOrgSuccessImage.fields.file.url ? (
                    <div className="text-lg text-grey-2 flex flex-col items-center mt-2">
                        <img
                            className="max-w-lg max-h-72"
                            src={successTexts?.joinOrgSuccessImage.fields.file.url}
                        />
                    </div>
                ) : null}
                {successTexts?.joinOrgSuccessTextLinkCopy ? (
                    <div className="text-lg text-grey-2 flex flex-col items-center mt-10">
                        <Btn onClick={onClose}>{successTexts?.joinOrgSuccessTextLinkCopy}</Btn>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
